import React from 'react';
import { useTranslation } from 'react-i18next';

export const Solutions = () => {
  const { t } = useTranslation();
  
  return (
    <section className="solutions">
      <div className="solution-items">
        <div className="solution">
          <img src="/images/webdesk.png" alt={t('solutionsSection.webdesk.title')} className="solution-image" />
          <h3>{t('solutionsSection.webdesk.title')}</h3>
          <p>{t('solutionsSection.webdesk.description')}</p>
          <ul className="solution-features">
            {(t('solutionsSection.webdesk.features', { returnObjects: true }) as string[]).map((feature: string, index: number) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
        </div>
        <div className="solution coming-soon">
          <img src="/images/archinote.png" alt={t('solutionsSection.archinote.title')} className="solution-image" />
          <h3>{t('solutionsSection.archinote.title')}</h3>
          <p>{t('solutionsSection.archinote.description')}</p>
          <div className="coming-soon-badge">{t('solutionsSection.archinote.comingSoon')}</div>
        </div>
        <div className="solution coming-soon">
          <img src="/images/benef.png" alt={t('solutionsSection.benef.title')} className="solution-image" />
          <h3>{t('solutionsSection.benef.title')}</h3>
          <p>{t('solutionsSection.benef.description')}</p>
          <div className="coming-soon-badge">{t('solutionsSection.benef.comingSoon')}</div>
        </div>
      </div>
    </section>
  );
};
